import { C, t } from '../constants/dashboardConstants';
import { getScheduleAccentBackground, normalizeScheduleColor } from './scheduleColors';

function toDateStr(date) {
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

export default function UpcomingPanel({ events, onEventClick, maxItems = 5 }) {
  const today = toDateStr(new Date());
  const upcoming = events
    .filter(e => e.date >= today)
    .sort((a, b) => a.date.localeCompare(b.date))
    .slice(0, maxItems);

  return (
    <div style={{
      width: '300px', flexShrink: 0,
      background: C.white, border: `1px solid ${C.g200}`,
      borderRadius: '20px', padding: '30px',
      boxShadow: C.shadow,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginBottom: '20px' }}>
        <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
          <circle cx="12" cy="12" r="9" stroke={C.bk} strokeWidth="1.5"/>
          <path d="M12 7v5l3 3" stroke={C.bk} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
        <span style={t('18px', 600, C.bk)}>다가오는 일정</span>
      </div>

      {upcoming.length === 0 ? (
        <div style={{
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          background: C.bg, border: `1px solid ${C.g200}`, borderRadius: '12px',
          height: '200px',
        }}>
          <span style={t('14px', 400, C.sub)}>예정된 일정이 없습니다.</span>
        </div>
      ) : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
          {upcoming.map(ev => {
            const color = normalizeScheduleColor(ev.color || ev.eventColor);
            return (
            <button key={ev.id} type="button" onClick={() => onEventClick?.(ev)} style={{
              width: '100%',
              background: getScheduleAccentBackground(color), border: `1px solid ${color}`,
              borderRadius: '10px', padding: '14px 16px',
              textAlign: 'left', cursor: onEventClick ? 'pointer' : 'default',
              appearance: 'none',
            }}>
              <span style={{ ...t('14px', 500, color), display: 'block' }}>{ev.title}</span>
              <span style={{ ...t('12px', 400, C.sub), display: 'block', marginTop: '4px' }}>
                {ev.date} {ev.time}
              </span>
            </button>
          );
          })}
        </div>
      )}
    </div>
  );
}
